import { Button } from '@ps-design-system/components/Button';
import { Spinner } from '@ps-design-system/components/Spinner';
import XIcon from '@ps-design-system/icons/X/X24';
import React from 'react';
import BootstrapModal from 'shared-components/modal/bootstrap-modal';

export class CateringLoadingModal extends React.Component {
  render() {
    return (
      <BootstrapModal
        {...this.props}
        modalSize="lg-size"
        modalClass="catering-menu-form-modal catering-loading-modal"
        header={
          <div className="relative">
            <Button
              className="absolute"
              style={{ top: '0', right: '0' }}
              iconOnly={true}
              variant="text-only"
              onClick={this.props.closeModal}
            >
              <XIcon />
            </Button>
          </div>
        }
        body={
          <div
            style={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '24px'
            }}
          >
            <Spinner size="large" appearance="black" />
            <p className="tw-body-4">
              Hold tight while we transfer you to our food provider, Cozymeal
            </p>
          </div>
        }
        addCloseIcon={true}
      />
    );
  }
}
